import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from 'react-router-dom';

import Home from './containers/Home/Home';
import About from './containers/About/About';
// import Blog from './containers/Blog/Blog';
import Services from './containers/Services/Services';
import Products from './containers/Products/Products';
import ServiceDetail from './containers/ServiceDetail/ServiceDetail';
import ScrollTop from './components/ScrollTop';
import RouteTracker from './components/RouteTracker';


class App extends Component {
  routeChanged() {
    console.log(arguments);
  }
  render() {
    return (
      <Router>
        <ScrollTop>
          <RouteTracker>
            <div>
	            <Switch>
	              <Route exact path="/" component={Home} />
	              <Route path="/about" component={About} />
	              {/* <Route path="/blog" component={Blog} /> */}
	              <Route path="/products" component={Products} />
	              <Route path="/services" component={Services} />
	              <Route path="/service/:serviceName" component={ServiceDetail} />
	              <Route component={Home} />
              </Switch>
            </div>
          </RouteTracker>
        </ScrollTop>
      </Router>
    );
  }
}

export default App;





// WEBPACK FOOTER //
// ./src/App.js